import { Button, PaperClipIcon } from '@st/theme'
import { inflect } from '@st/util/inflect'
import { ClientOrganizerSaveIndicator } from './client-organizer-save-indicator'

type Props = {
  documentsCount: number
  onClickViewAttachments: () => void
  onClose: () => void
}
export function STQuestionnaireTrailingHeader({
  documentsCount,
  onClickViewAttachments,
  onClose
}: Props) {
  return (
    <div className="flex flex-row items-center gap-2">
      <ClientOrganizerSaveIndicator className="hidden lg:flex" />
      <div className="hidden md:flex">
        <Button
          variant="default"
          leadingIcon={<PaperClipIcon className="h-4 w-4" />}
          onClick={onClickViewAttachments}
        >
          {documentsCount} {inflect(documentsCount, 'Attachment')}
        </Button>
      </div>
      <Button variant="default" onClick={onClose}>{`Save & close`}</Button>
    </div>
  )
}
